import { ApiService } from "./AbstractApiService";
import {
  IEventManagement,
  IEventManagementFormModel,
  IEventManagements,
} from "@/interfaces/iEventManagement";
import qs from "qs";
import { IPageModel } from "@/interfaces/iPageModel";
import moment from "moment";
export class EventManagementAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }
  private static instance: EventManagementAPI | null;
  // constructor() {
  //   super("email");
  // }

  // GET ALL EVENTS
  public async getEventManagementList(
    queryParams?: Record<string, string | number>
  ): Promise<IPageModel<IEventManagement>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get("notification/events", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async getEventManagementFormList(
    id: number,
    params?: Record<string, string | number>
  ): Promise<IPageModel<IEventManagementFormModel>> {
    return this.get(`notification/eventForms/${id}/forms`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async deleteEventManagementForm(
    id: number,
    payload: any
  ): Promise<IPageModel<IEventManagementFormModel>> {
    return this.service
      .delete(`notification/eventForms/${id}/forms`, { data: payload })
      .then((response) => response.data);
  }

  public async addEventManagementForm(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<IEventManagements>> {
    if (edit) {
      return this.put(
        `notification/eventForms/` + payload?.webId,
        payload
      ).then((response) => response.data);
    } else {
      return this.post(`notification/eventForms`, payload).then(
        (response) => response.data
      );
    }
  }

  public async getEvent(id: number): Promise<IEventManagements> {
    return this.get(`notification/events/${id}`).then(
      (response) => response.data
    );
  }
  //GET ALL SCHEDULE TYPES
  public getAllScheduleTypes() {
    return this.get(
      "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKEventType",
      {}
    ).then((response) => response.data);
  }

  public getAllScheduleEventTypes() {
    return this.get("notification/filter/EMAIL_EVENT_TYPE", {}).then(
      (response) => response.data
    );
  }

  public getAllScheduleEventSubTypes(siteId?) {
    return this.get(
      `notification/filter/EMAIL_EVENT_CONFIG?siteIds=${siteId ? siteId : ""}`,
      {}
    ).then((response) => response.data);
  }

  public getAllScheduleProviders() {
    return this.get("notification/filter/EMAIL_CONFIG", {}).then(
      (response) => response.data
    );
  }

  //GET ALL SCHEDULE TEMPLATES
  public getAllScheduleTemplates(subType) {
    return this.get(`notification/filter/TEMPLATE?subType=${subType}`, {}).then(
      (response) => response.data
    );
  }

  //GET ALL SCHEDULE DYNAMIC SHORTCUTS
  public getAllScheduleDynamicShortcuts() {
    return this.get("notification/filter/DYNAMIC_SHORTCUT", {}).then(
      (response) => response.data
    );
  }

  //GET ALL SCHEDULE BODY
  public getAllScheduleBody(template) {
    return this.get("notification/templates/" + template, {}).then(
      (response) => response.data
    );
  }

  //GET ALL SCHEDULE RECEIPENTS
  public getAllScheduleReceipents() {
    return this.get("security/filter/USER_EMAIL_ROLE", {}).then(
      (response) => response.data
    );
  }
  // getPhoneScheduleReceipents
  public getPhoneScheduleReceipents() {
    return this.get("security/filter/USER_PHONE", {}).then(
      (response) => response.data
    );
  }
  // ADD Event
  public async addEvent(
    payload?: any,
    edit?: boolean
  ): Promise<IPageModel<IEventManagement>> {
    console.log("in service" + payload);
    if (edit) {
      return this.put("notification/events/" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("notification/events", payload).then(
        (response) => response.data
      );
    }
  }

  // APPLY Bulk Delete
  public bulkDeleteEntity(entity: string, params: string[]) {
    return this.service
      .delete(`${entity}`, { data: params })
      .then((response) => response.data);
  }

  public transformDateRangeParams(
    params: Record<string, string | number>
  ): Record<string, string | number> {
    if (
      params &&
      params["startDate"] &&
      `${params["startDate"]}`.split(",").length > 1
    ) {
      const dates = `${params["startDate"]}`.split(",");
      params["startDate"] = moment(dates[0]).format("YYYY-MM-DDTHH:mm:ss[Z]");

      const endDate = new Date(dates[1]);
      endDate.setHours(23, 59, 59);

      // Format the end date as a string without converting to UTC
      const endDateString = `${endDate.getFullYear()}-${String(
        endDate.getMonth() + 1
      ).padStart(2, "0")}-${String(endDate.getDate()).padStart(
        2,
        "0"
      )}T${String(endDate.getHours()).padStart(2, "0")}:${String(
        endDate.getMinutes()
      ).padStart(2, "0")}:${String(endDate.getSeconds()).padStart(2, "0")}Z`;

      params["endDate"] = endDateString;
    }

    const { ...rest } = params;
    return rest;
  }
}
